import type { ProviderUnblockAudio } from "../types";

export const useLivekitUnblockAudio = (): ProviderUnblockAudio => ({
  isAudioBlocked: false,
  unblockAudio: () => Promise.resolve(),
});
